export const ARIA = "ARIA";
// export const ARIA = [{ name: "ARIA", dollhousemapId: "DlHse_RO_Aria_L1" }];
export const VDARA = "VDARA AT ARIA";
export const BELLAGIO = "BELLAGIO";
export const PARK_MGM = "PARK MGM";
export const THE_COSMOPOLITAN = "THE COSMOPOLITAN OF LAS VEGAS";
export const NOMAD = "The Reserve at Park MGM";
export const DISTRICT_HIGHLIGHTS = "DISTRICT HIGHLIGHTS";
export const ADDITIONAL = "ADDITIONAL";
export const TMOBILE = "T-MOBILE ARENA";
export const DOLBY = "DOLBY LIVE";

export const Modal_Left = "isometric-modal isometric-modal-left";
export const Modal_Left_Display =
  "isometric-modal isometric-modal-left isometric-display";
export const Modal_Left_Top = "isometric-modal isometric-modal-left-top";
export const Modal_Left_Top_Display =
  "isometric-modal isometric-modal-left-top isometric-display";
export const Modal_Left_Bottom = "isometric-modal isometric-modal-left-bottom";
export const Modal_Left_Bottom_Display =
  "isometric-modal isometric-modal-left-bottom isometric-display";

export const Modal_Right = "isometric-modal isometric-modal-right";
export const Modal_Right_Display =
  "isometric-modal isometric-modal-right isometric-display";
export const Modal_Right_Top = "isometric-modal isometric-modal-right-top";
export const Modal_Right_Top_Display =
  "isometric-modal isometric-modal-right-top isometric-display";
export const Modal_Right_Bottom =
  "isometric-modal isometric-modal-right-bottom";
export const Modal_Right_Bottom_Display =
  "isometric-modal isometric-modal-right-bottom isometric-display";

export const ARIA_INFORMATION =
  "ARIA Resort & Casino is a stunning AAA Five Diamond resort featuring world-class dining experiences, premium 500,000 sq ft of meeting and convention space, striking architecture and sustainable design. Inspire the flow of new ideas with an unconventional space for your next meeting.";
export const VDARA_INFORMATION =
  "Vdara Hotel & Spa is an all-suite, non-gaming, smoke-free hotel. With a Forbes Travel Guide Five-Star-rated Spa, sophisticated lobby bar and casual eatery, Vdara creates an intimate and inviting environment with 16,500+ square feet of conference space.";
export const BELLAGIO_INFORMATION =
  "Bellagio Resort & Casino is pure AAA Five-Diamond awarded luxury. With more than 200,000 square feet of elegant meeting space, Bellagio offers an artful blend of imagination, sophistication and creativity for events of all types – from intimate gatherings to convention groups of more than 5,000 attendees.";
export const PARK_MGM_INFORMATION =
  " Park MGM and NoMad Hotel Las Vegas bring approachable restaurants, lounges, shops and bars all under one roof and is fully smoke-free. With 77,000 sq. ft. of indoor and outdoor flexible space, Park MGM offers a fresh place to inspire, connect and collaborate. ";
export const COSMO_INFORMATION =
  "Featuring modern, oversized guest rooms with private terraces and breathtaking views of the Las Vegas skyline, The Cosmopolitan of Las Vegas, brings new offerings to the Luxury Meetings District.With nearly 240,000 square feet of convenient and unique meeting space, The Cosmopolitan offers spaces for groups from 10 to 2,000.";
export const TMOBILE_INFORMATION =
  "In the center of the Luxury Meetings District is T-Mobile Arena, the 650,000-squaree-foot arena that seats 20,000 attendees for award shows, concerts, sporting events and other special events.";
